import { Route, Routes } from 'react-router-dom';
import Home from "./screens/home/Home";

const App = () => {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Home/>} />
      </Routes>
    </div>
  );
};

export default App;
